import Vue from 'vue';
export default Vue.extend({
    name: 'Tooltip',
    props: {
        tooltipProps: {
            type: Object,
            default: () => ({ qTooltipProps: {} })
        }
    },
    computed: {
        computedProps() {
            return Object.assign(Object.assign({}, this.tooltipProps.qTooltipProps), { delay: 600 });
        }
    }
});
